<template>
	<div class="container__builderall">
		<div class="container__builderall--header">
			<div 
				@click="changeTab('request')"
				:class="['header__item', { 'header__item--active': activeComponent == 'request' }]"
				v-html="translations.tabs.team_account">
			</div>
			<div 
				@click="changeTab('member')"
				:class="['header__item', { 'header__item--active': activeComponent == 'member' }]"
				v-html="translations.tabs.team_account_im_member">
			</div>

		</div>
		<div class="container__builderall--content">
			<transition-group name="component-fade" mode="out-in">
				<team-account-member
					key="member"
					v-show="activeComponent == 'member'"
					:team="team"
				    :teams_participate="teams_participate"
				    :office_usuario_id="office_usuario_id"
				    :handler_routes="handler_routes"
				    :t = "translations.user">
				</team-account-member>

				<team-account-request
					key="request"
					v-show="activeComponent == 'request'"
					:team="team"
				    :teams_participate="teams_participate"
				    :office_usuario_id="office_usuario_id"
				    :handler_routes="handler_routes"
				    :t = "translations.user"
				    :office_usuario_pag_status = "office_usuario_pag_status">
				</team-account-request>
			</transition-group>
		</div>
	</div>
</template>

<script type="text/javascript">
	import TeamAccountRequest from './request.vue';
	import TeamAccountMember from './member.vue';

	export default {
	  name: "team-account-user",
	  props: ["team","teams_participate","handler_routes","office_usuario_id","translations", "office_usuario_pag_status"],

	  data() {
	    return {
	    	activeComponent: 'request'
	    };
	  },

	  methods:{
	  	changeTab(tab){
	  		this.activeComponent = tab
	  	}
	  }
	}
</script>

<style scoped lang="scss">
@import '../../../scss/team-account/style.scss';
.component-fade-enter-active {
  transition: all .3s ease;
}
.component-fade-leave-active {
  display: none;
}
.component-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.component-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}



</style>


// WEBPACK FOOTER //
// resources/office/js/components/team-account/user.vue